/* tslint:disable */
/* eslint-disable */
/**
 * Torrents Stream Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface MagnetModel
 */
export interface MagnetModel {
    /**
     *
     * @type {string}
     * @memberof MagnetModel
     */
    magnet: string
}

export function MagnetModelFromJSON(json: any): MagnetModel {
    return MagnetModelFromJSONTyped(json, false)
}

export function MagnetModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): MagnetModel {
    if (json === undefined || json === null) {
        return json
    }
    return {
        magnet: json['magnet'],
    }
}

export function MagnetModelToJSON(value?: MagnetModel | null): any {
    if (value === undefined) {
        return undefined
    }
    if (value === null) {
        return null
    }
    return {
        magnet: value.magnet,
    }
}
